module.exports = __webpack_public_path__ + "img/procedures.6a1cac0b.svg";